import React, { Component, PropTypes } from 'react';
import { Button } from 'reactstrap';

import NavBar from './NavBar';
import NavLink from './NavLink';
import {spaceToUnderscore} from "../helpers/helpers";

class AssignmentFileSubmissionFormLinks extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { assignment, dropbox, handleExit } = this.props;

        return (
            <NavBar
                className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
            >
                <NavLink
                    to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/edit`}
                    className=""
                    side="left"
                    display
                    key="exit"
                >
                    <Button
                        type="button"
                        onClick={()=>{}}
                        size="md"
                        color="outline-primary"
                        title={'Exit'}
                    >
                        Exit <i className={"fa fa-chevron-circle-left"}/>
                    </Button>
                </NavLink>
            </NavBar>
        );
    }
}


AssignmentFileSubmissionFormLinks.propTypes = {
    dropbox: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired,
    handleExit: PropTypes.func,
};

export default AssignmentFileSubmissionFormLinks;


/** WEBPACK FOOTER **
 ** ./src/components/AssignmentFileSubmissionFormLinks.js
 **/